module.exports = __webpack_public_path__ + "eac943b99bdbc3564b129081da98f40e.svg";